import { indexOf } from 'lodash'
import { keepMediaIndexInBoundaries } from 'redux/navigation/selectors'
import { getMediaThreshold } from 'redux/configuration/selectors'

export const isFetchedMedia = (state, index) => indexOf(state.fetchingMedia, index) !== -1

export const fetchingMediaBoundaries = (state, index) => {

    const batchSize = getMediaThreshold(state)

    return {
        start: keepMediaIndexInBoundaries(state, index - batchSize),
        end: keepMediaIndexInBoundaries(state, index + batchSize),
    }
}
